<template>
    <div class="pt-3">
        <div class="rounded-xl m-0 bg-blue-50 border-gray-200 border p-4 text-gray-500 italic text-center">
            <template v-if="estimateClipboardItem">
                <div class="mb-0.5" v-text="`Currently in your 'Estimate' clipboard`"/>
                <div class="font-semibold"
                     v-text="estimateClipboardItem.title+' - '+estimateClipboardItem.reference +' ('+toCurrency(estimateClipboardItem.total)+')'"></div>
                <div class="mt-3">
                    <button
                        class="bg-white border ml-2 px-2 py-1 text-gray-600 rounded-xl hover:bg-gray-50 hover:border-gray-400 text-xs"
                        @click="addAsNamed">Add as a Named 'Estimate'
                    </button>
                    <button
                        class="bg-white border ml-2 px-2 py-1 text-gray-600 rounded-xl hover:bg-gray-50 hover:border-gray-400 text-xs"
                        @click="clear">Empty 'Estimate' Clipboard
                    </button>
                </div>
            </template>
            <template v-else>
                You have no Estimate currently in your clipboard
            </template>
        </div>
        <hr/>
        <div class="mb-0.5" v-text="`Named 'Estimates' that can be pasted :`"/>
        <div class="flex border-t border-l border-r -mb-px border-gray-200 bg-blue-50 mt-4 rounded-t-lg">
            <div class="w-6 flex-shrink-0 self-start pt-2 m-0 border-none pl-1 pr-1"></div>
            <div class="flex-1 flex -ml-px">
                <div class="m-0 px-px py-px pb+px border-gray-200">
                    <div
                        class="col-span-full m-0 px-2 py-1.5 shadow-none relative hover:z-10 focus:z-20 resize-none text-xs font-semibold">
                        Estimate Library
                    </div>
                </div>
            </div>
            <div class="w-6 flex-shrink-0 self-start pt-2 m-0 border-none pl-1 pr-1"></div>
        </div>
        <draggable :list="namedClipboardItems" draggable=".draggable" handle=".handle" group="namedItems"
                   @change="reordered"
                   :key="'named'+clipboardKey" v-if="(namedClipboardItems.length > 0)">
            <div class="flex m-0 border-gray-200 draggable hover:z-20" v-for="item in namedClipboardItems">
                <div class="w-6 py-1.5 m-0 -mt-px border-t border-b bg-white">
                    <div class="w-5 h-5 flex items-center pl-1">
                        <i class="fa fa-bars fa-fw text-xs text-gray-300 hover:text-gray-400 cursor-move handle"></i>
                    </div>
                </div>
                <div class="flex w-full truncate m-0 -mt-px">
                    <page-cell
                        class="text-xs flex text-blue-500 truncate border border-gray-200 m-0 px-2 pt-2 bg-white focus:z-20"
                        placeholder="Estimate name..."
                        v-model="item.name"
                        @change="updateClipboard"
                    ></page-cell>
                </div>
                <div class="w-6 pt-2 m-0 -ml-px -mt-px border-t border-b bg-white">
                    <ui-dropdown menu-class="p-3 w-72">
                        <template #default="{ toggle }">
                            <button @click="toggle"
                                    class="w-5 h-5 flex items-center justify-center text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative rounded">
                                <i class="fa fa-ellipsis-h fa-fw pl-1 pr-1"></i>
                            </button>
                        </template>
                        <template #menu="{ close }">
                            <ui-dropdown-item icon="fas fa-trash" danger
                                              @click="deleteItem(item);close();">Delete
                            </ui-dropdown-item>
                        </template>
                    </ui-dropdown>
                </div>

            </div>
        </draggable>
        <div class="border -mt-px -mb-px p-4 border-gray-200 bg-grey-50 text-gray-500" v-else>
            <div class="mb-2 text-center font-semibold italic">None</div>
            <div class="mb-2 text-center text-xs">
                No named estimates exist - add an estimate to your clipboard and then select "Add as a Named 'Estimate'"
                to store it as a paste-able named estimate
            </div>
        </div>
        <div class="border -mt-px -mb-px border-gray-200 bg-blue-50 rounded-b-lg">
            &nbsp
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable"
import UiTextarea from "../../../ui/UiTextarea.vue";
import UiFormSection from "../../../ui/UiFormSection.vue";
import UiDropdownItem from "../../../ui/UiDropdownItem.vue";
import UiSelect from "../../../ui/UiSelect.vue";
import remoteStorage from "../../../../utils/remoteStorage";
import {toCurrency} from "../../../../utils";
import PageCell from "../../../ui/PageCell.vue";

export default {
    components: {
        draggable,
        PageCell, UiSelect, UiDropdownItem, UiFormSection, UiTextarea
    },
    props: {
        user: Object,
    },
    watch: {
        userClipboardToBeWatched: {
            handler(newValue, oldValue) {
                let d = this.fetchClipboardData();
                this.estimateClipboard = d.estimateClipboard
                this.clipboardKey++
            },
        },
    },
    computed: {
        estimateClipboardItem() {
            return this.estimateClipboard.length ? this.estimateClipboard[0] : null
        },
        userClipboardToBeWatched() {
            return this.user.remoteStorage ? this.user.remoteStorage['estimate-clipboard']
                : ''
        },
        namedClipboardItems() {
            if (this.estimateClipboard.length > 1) {
                let i = this.estimateClipboard.slice()
                i.splice(0, 1)
                return i
            }
            return [];
        }
    },
    data() {
        let d = this.fetchClipboardData();
        return {
            estimateClipboard: d.estimateClipboard,
            clipboardKey: 0,
        }
    },
    async mounted() {

    },
    methods: {
        addAsNamed() {
            this.estimateClipboard.push({
                name: (this.estimateClipboard[0].title + ' - ' + this.estimateClipboard[0].reference + ' (' + toCurrency(this.estimateClipboard[0].total) + ')').replace(/(\r\n|\n|\r)/gm, ""),
                data: this.estimateClipboard[0]
            })
            this.updateClipboard()
        },
        clear() {
            this.estimateClipboard[0] = null;
            this.updateClipboard()
        },
        deleteItem(item) {
            this.estimateClipboard = this.estimateClipboard.filter((e) => e !== item)
            this.updateClipboard()
        },
        updateClipboard() {
            this.clipboardKey++
            remoteStorage.setItem('estimate-clipboard', JSON.stringify(this.estimateClipboard))
        },
        reordered(e) {
            let item = this.estimateClipboard.splice(e.moved.oldIndex + 1, 1)
            this.estimateClipboard.splice(e.moved.newIndex + 1, 0, item[0])
            this.updateClipboard()
        },
        toCurrency,
        fetchClipboardData() {
            return {
                estimateClipboard: remoteStorage.getItem('estimate-clipboard') ? this.jsonParse(remoteStorage.getItem('estimate-clipboard')) : [],
            }
        },
        jsonParse(data) {
            try {
                return JSON.parse(data)
            } catch (e) {
                return []
            }
        }
    }
}
</script>
